import { useQuery } from "@tanstack/react-query";
import { adminApi } from "../api";
import { EmptyState, Panel } from "../components/DataTable";

export function CustomersPage() {
  const query = useQuery({ queryKey: ["admin-customers"], queryFn: adminApi.customers });
  const customers = query.data?.customers ?? [];
  return (
    <Panel title="Clientes Shopify">
      {!query.data?.connected && <p className="mb-3 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">Shopify ainda nao conectado. Configure scopes de clientes e credenciais do app.</p>}
      {!customers.length ? <EmptyState text="Nenhum cliente carregado." /> : (
        <div className="overflow-auto">
          <table className="w-full min-w-[860px] text-left text-sm">
            <thead className="text-xs uppercase text-slate-500">
              <tr><th className="py-2">Cliente</th><th>Contato</th><th>Pedidos</th><th>Total gasto</th><th>Local</th></tr>
            </thead>
            <tbody>
              {customers.map((customer) => (
                <tr key={customer.id} className="border-t border-line">
                  <td className="py-2"><p className="font-semibold">{[customer.firstName, customer.lastName].filter(Boolean).join(" ") || "-"}</p><p className="font-mono text-xs text-slate-500">{customer.id}</p></td>
                  <td><p>{customer.email ?? "-"}</p><p className="text-xs text-slate-500">{customer.phone ?? "-"}</p></td>
                  <td>{customer.numberOfOrders}</td>
                  <td>{customer.amountSpent ? `${customer.amountSpent.currencyCode} ${customer.amountSpent.amount}` : "-"}</td>
                  <td>{[customer.defaultAddress?.city, customer.defaultAddress?.provinceCode, customer.defaultAddress?.countryCodeV2].filter(Boolean).join(", ") || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  );
}
